// extracted by mini-css-extract-plugin
export default {"category_card_wrapper":"CategoryCard_category_card_wrapper__Co5EK","image_wrapper":"CategoryCard_image_wrapper__I28Gb","card_text_wrapper":"CategoryCard_card_text_wrapper__rq0uq"};